import { modelUuidsInputUrlStore } from "../inputs/modelUuidsInputUrlStore.ts";
import type { BoardState } from "../types.ts";
import type { InputUrlStore } from "./createInputUrlStore.ts";

// XXX: This function is aimed to group all the input url params that can be used to set the board state so we can easily extend it when needed.
export const retrieveAndClearInputUrlParams = (): Partial<BoardState> => ({
  ...getAndClearInputUrlParam({
    boardStateKey: "modelUuids",
    inputUrlStore: modelUuidsInputUrlStore,
  }),
});

const getAndClearInputUrlParam = <T>({
  boardStateKey,
  inputUrlStore,
}: {
  boardStateKey: keyof BoardState;
  inputUrlStore: InputUrlStore<T>;
}): Partial<BoardState> => {
  const value = inputUrlStore.getInputUrlParam();
  inputUrlStore.clear();
  return value !== undefined ? { [boardStateKey]: value } : {};
};
